// DO NOT EDIT THIS FILE!
// This file was generated by ubi-generators (https://ghe.spotify.net/datainfra/ubi-generators).
// For support, contact us on the #ubi-users Slack channel.
const SPECIFICATION_ID = "web-support-home";
const APP = "support-spotify-com";
const SPECIFICATION_VERSION = "3.0.0";
const SPECIFICATION_MODE = "default";
const GENERATOR_VERSION = "16.0.1";
/**
 * Creates an event factory to generate events
 * @params options - The required context for this specification
 *  - `option.data`: Required metadata for root parameters
 *  - {string} `option.data.identifier`: An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
 *  - {string} `option.data.uri`: A URI for the node required by the specification. This data is encrypted by default
 * @returns {WebSupportHomeEventFactory} A new instance of WebSupportHomeEventFactory
 */
export function createWebSupportHomeEventFactory(options) {
    return new WebSupportHomeEventFactory(options);
}
/**
 * Landing page of the support site
 */
export class WebSupportHomeEventFactory {
    constructor(options) {
        this._path = [{
                name: SPECIFICATION_ID,
                ...options.data
            }];
        if (options?.parentAbsoluteLocation) {
            this._parentAbsoluteLocation = options.parentAbsoluteLocation;
        }
    }
    /**
     * Creates a new instance of SearchInputEventFactory
     * @returns {SearchInputEventFactory}  A new instance of SearchInputEventFactory
     */
    searchInputFactory() {
        return new WebSupportHomeEventFactory.SearchInputEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    /**
     * Creates a new instance of SearchResultEventFactory
     * @param {Object} data - The required metadata for this element node.
     * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
     * @param {number} data.position- A position for the node required by the specification
     * @returns {SearchResultEventFactory}  A new instance of SearchResultEventFactory
     */
    searchResultFactory(data) {
        return new WebSupportHomeEventFactory.SearchResultEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation,
            data
        });
    }
    /**
     * Creates a new instance of ParentCategoryCardContainerEventFactory
     * @returns {ParentCategoryCardContainerEventFactory}  A new instance of ParentCategoryCardContainerEventFactory
     */
    parentCategoryCardContainerFactory() {
        return new WebSupportHomeEventFactory.ParentCategoryCardContainerEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    /**
     * Creates a new instance of QuickLinkContainerEventFactory
     * @returns {QuickLinkContainerEventFactory}  A new instance of QuickLinkContainerEventFactory
     */
    quickLinkContainerFactory() {
        return new WebSupportHomeEventFactory.QuickLinkContainerEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    /**
     * Creates a new instance of CommunityLinkEventFactory
     * @returns {CommunityLinkEventFactory}  A new instance of CommunityLinkEventFactory
     */
    communityLinkFactory() {
        return new WebSupportHomeEventFactory.CommunityLinkEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    /**
     * Creates a new instance of LoginButtonEventFactory
     * @returns {LoginButtonEventFactory}  A new instance of LoginButtonEventFactory
     */
    loginButtonFactory() {
        return new WebSupportHomeEventFactory.LoginButtonEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    _getCurrentLocation() {
        return {
            pathNodes: this._path,
            specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
            specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
        };
    }
    getAbsoluteLocation() {
        const parentLocations = this._parentAbsoluteLocation?.locations;
        return {
            locations: [
                ...(parentLocations || []),
                this._getCurrentLocation()
            ],
        };
    }
}
(function (WebSupportHomeEventFactory) {
    /**
     * Create SearchInputEventFactory class with path
     * @param path to this node
     */
    class SearchInputEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "search_input"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create interaction for hit focus_input_field action.
         */
        hitFocusInputField() {
            const data = {
                actionName: "focus_input_field",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
        /**
         * Create interaction for key_stroke change_search_query action.
       * @param search_query_string the search_query_string field
         */
        keyStrokeChangeSearchQuery({ searchQueryString }) {
            const data = {
                actionParameterNames: ['search_query_string'],
                actionParameterValues: [searchQueryString.toString()],
                actionName: "change_search_query",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "key_stroke",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportHomeEventFactory.SearchInputEventFactory = SearchInputEventFactory;
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
(function (WebSupportHomeEventFactory) {
    /**
     * Create SearchResultEventFactory class with path
     * @param path to this node
     */
    class SearchResultEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                ...data,
                name: "search_result"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create interaction for hit ui_navigate action.
       * @param destination the destination field
         */
        hitUiNavigate({ destination }) {
            const data = {
                actionParameterNames: ['destination'],
                actionParameterValues: [destination.toString()],
                actionName: "ui_navigate",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
        /**
         * Create impression for SearchResultEventFactory.
         */
        impression() {
            const data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportHomeEventFactory.SearchResultEventFactory = SearchResultEventFactory;
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
(function (WebSupportHomeEventFactory) {
    /**
     * Create ParentCategoryCardContainerEventFactory class with path
     * @param path to this node
     */
    class ParentCategoryCardContainerEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "parent_category_card_container"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        /**
         * Creates a new instance of ParentCategoryCardLinkEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
         * @param {number} data.position- A position for the node required by the specification
         * @returns {ParentCategoryCardLinkEventFactory}  A new instance of ParentCategoryCardLinkEventFactory
         */
        parentCategoryCardLinkFactory(data) {
            return new WebSupportHomeEventFactory.ParentCategoryCardContainerEventFactory.ParentCategoryCardLinkEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
    }
    WebSupportHomeEventFactory.ParentCategoryCardContainerEventFactory = ParentCategoryCardContainerEventFactory;
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
(function (WebSupportHomeEventFactory) {
    /**
     * Create QuickLinkContainerEventFactory class with path
     * @param path to this node
     */
    class QuickLinkContainerEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "quick_link_container"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        /**
         * Creates a new instance of QuickLinkEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
         * @param {number} data.position- A position for the node required by the specification
         * @returns {QuickLinkEventFactory}  A new instance of QuickLinkEventFactory
         */
        quickLinkFactory(data) {
            return new WebSupportHomeEventFactory.QuickLinkContainerEventFactory.QuickLinkEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create impression for QuickLinkContainerEventFactory.
         */
        impression() {
            const data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportHomeEventFactory.QuickLinkContainerEventFactory = QuickLinkContainerEventFactory;
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
(function (WebSupportHomeEventFactory) {
    /**
     * Create CommunityLinkEventFactory class with path
     * @param path to this node
     */
    class CommunityLinkEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "community_link"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create interaction for hit ui_navigate action.
       * @param destination the destination field
         */
        hitUiNavigate({ destination }) {
            const data = {
                actionParameterNames: ['destination'],
                actionParameterValues: [destination.toString()],
                actionName: "ui_navigate",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportHomeEventFactory.CommunityLinkEventFactory = CommunityLinkEventFactory;
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
(function (WebSupportHomeEventFactory) {
    /**
     * Create LoginButtonEventFactory class with path
     * @param path to this node
     */
    class LoginButtonEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "login_button"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create interaction for hit ui_navigate action.
       * @param destination the destination field
         */
        hitUiNavigate({ destination }) {
            const data = {
                actionParameterNames: ['destination'],
                actionParameterValues: [destination.toString()],
                actionName: "ui_navigate",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
        /**
         * Create impression for LoginButtonEventFactory.
         */
        impression() {
            const data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportHomeEventFactory.LoginButtonEventFactory = LoginButtonEventFactory;
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
(function (WebSupportHomeEventFactory) {
    var ParentCategoryCardContainerEventFactory;
    (function (ParentCategoryCardContainerEventFactory) {
        /**
         * Create ParentCategoryCardLinkEventFactory class with path
         * @param path to this node
         */
        class ParentCategoryCardLinkEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "parent_category_card_link"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_navigate action.
           * @param destination the destination field
             */
            hitUiNavigate({ destination }) {
                const data = {
                    actionParameterNames: ['destination'],
                    actionParameterValues: [destination.toString()],
                    actionName: "ui_navigate",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for ParentCategoryCardLinkEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        ParentCategoryCardContainerEventFactory.ParentCategoryCardLinkEventFactory = ParentCategoryCardLinkEventFactory;
    })(ParentCategoryCardContainerEventFactory = WebSupportHomeEventFactory.ParentCategoryCardContainerEventFactory || (WebSupportHomeEventFactory.ParentCategoryCardContainerEventFactory = {}));
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
(function (WebSupportHomeEventFactory) {
    var QuickLinkContainerEventFactory;
    (function (QuickLinkContainerEventFactory) {
        /**
         * Create QuickLinkEventFactory class with path
         * @param path to this node
         */
        class QuickLinkEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "quick_link"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_navigate action.
           * @param destination the destination field
             */
            hitUiNavigate({ destination }) {
                const data = {
                    actionParameterNames: ['destination'],
                    actionParameterValues: [destination.toString()],
                    actionName: "ui_navigate",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for QuickLinkEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        QuickLinkContainerEventFactory.QuickLinkEventFactory = QuickLinkEventFactory;
    })(QuickLinkContainerEventFactory = WebSupportHomeEventFactory.QuickLinkContainerEventFactory || (WebSupportHomeEventFactory.QuickLinkContainerEventFactory = {}));
})(WebSupportHomeEventFactory || (WebSupportHomeEventFactory = {}));
